import Swiper from 'swiper';

export default function() {
  const newsSlider = document.querySelectorAll('.news-slider');

  newsSlider.forEach((block) => {
    const slider = block.querySelector('.swiper-container');

    const swiper = new Swiper(slider, {
      autoplay: {
        delay: 3000,
      },
      centeredSlides: true,
      direction: 'horizontal',
      slidesPerView: 'auto',
      speed: 1000,
      loop: true,
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: 'true',
      },
      keyboard: {
        enabled: true,
        pageUpDown: false,
      },
      breakpoints: {
        500: {
          centeredSlides: false,
          slidesPerView: 'auto',
        },
        999: {
          centeredSlides: false,
          slidesPerView: 4,
        }
      },
    });
  });
}
